

function game_100()
{

}

game_100.odd_map  = {
  "10":[0,0,0,0,0],
  "8":[0,0,20,60,500],
  "7":[0,0,15,50,200],
  "6":[0,0,15,25,150],
  "5":[0,0,10,20,100],
  "4":[0,0,10,15,50],
  "3":[0,0,5,8,10],
  "2":[0,0,5,8,10],
  "1":[0,0,5,8,10],
};

export {
  game_100
};



// WEBPACK FOOTER //
// ./src/components/slots/game_100.js